

export function toggleInArray(arr, value) {
    if (!Array.isArray(arr)) return [value];
    return arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
}